import DefaultLayout from '##/Default';
import List from './List';
import Signature from './Signature';
import UserAccess from './UserAccess';

const routes = [
    {
        path: '/users',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'Manage Users'
    },
    {
        path: '/user/signature',
        exact: true,
        layout: DefaultLayout,
        component: Signature,
        auth: true,
        title: 'Manage Digital Signature'
    },
    {
        path: '/users/:user_id/access',
        exact: true,
        layout: DefaultLayout,
        component: UserAccess,
        auth: true,
        title: 'Manage User Access'
    }
];

export default routes;
